import { Component, OnDestroy, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HasPageTitleAndMetaData, StaticPageInterface } from '@app/interfaces/_index';

import { ActivatedRoute } from '@angular/router';
import { StaticPage } from '@app/models/_index';
import { TermsAndConditionsService } from '@app/services/_index';
import { getPageIdBySlug } from '@app/utilities/_index';
import { Subscription } from 'rxjs';
import { StaticPageAdapter } from '../../adapters/_index';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  standalone: false,
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy, HasPageTitleAndMetaData {
  // Page Properties
  termsAndConditions: StaticPage;
  subs: Subscription[] = [];
  isLoading: boolean;

  constructor(
    private route: ActivatedRoute,
    private termsAndConditionsService: TermsAndConditionsService,
    private staticPageAdapter: StaticPageAdapter,
    private titleService: Title,
    private metaService: Meta
  ) {}

  /**
   * OnInit load page and Terms and Conditions title and metadata.
   * Load terms and conditions content from CMS
   */
  ngOnInit(): void {
    this.isLoading = true;
    // Load Terms and Conditions content from CMS
    this.getTermsAndConditions();
    // Set page title and metadata
    this.setTitleAndMetaData();
  }

  /**
   * Get terms and conditions response from wordpress service
   * @param termsAndConditionsId page id of the terms and conditions
   */
  getTermsAndConditions(): void {
    this.subs.push(
      this.route.parent.data.subscribe((value) => {
        const termsAndConditionsId = getPageIdBySlug(value.slug);
        this.getTermsAndConditionsById(termsAndConditionsId);
      })
    );
  }

  /**
   * Subscribe and set the terms and conditions
   * @param id page id of the terms and conditions
   */
  getTermsAndConditionsById(pageId: number): void {
    this.subs.push(
      this.termsAndConditionsService.getTermsAndConditions(pageId).subscribe({
        next: (response: StaticPageInterface[]) => {
          if (response && response.length > 0) {
            this.isLoading = false;
            const staticPages: StaticPage[] = response.map((item: StaticPageInterface) => {
              return this.staticPageAdapter.adapt(item);
            });

            if (staticPages && staticPages.length > 0) {
              const filteredStaticPage = staticPages.filter(
                (staticPage) => staticPage.id === pageId
              );
              if (filteredStaticPage && filteredStaticPage.length > 0) {
                this.termsAndConditions = filteredStaticPage[0];
              }
            }
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.log(error);
        },
        complete: () => {
          this.isLoading = false;
        },
      })
    );
  }

  /**
   * Set selected Terms and Conditions title and metadata tags
   */
  setTitleAndMetaData(): void {
    // NOTE: Update page title on Terms and Conditions page
    this.titleService.setTitle('Terms And Conditions | Genesys Education');
    // NOTE: Update meta tag description for page
    this.metaService.updateTag({
      name: 'description',
      content:
        'See all of your Genesys Education enrollments, certifications, and recommended learning in one place.',
    });
  }

  /**
   * On Destroy, unsubscribe subscriptions to prevent memory leaks
   */
  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
